import moment from 'moment'

export default {

    getDateFormatter: function () {
        return moment().format('YYYY-MM-DD')
    },
    formatLongDate: function (value) {
        if (value) {
            return moment(String(value)).format('DD/MM/YYYY hh:mm a')
            }
    },
    formatLongDateToSend: function (value) {
        if (value) {
            return moment(String(value)).format('DD/MM/YYYY hh:mm a')
            }
    },
}
